import { createSelector } from 'reselect';
import {
	EPIC_PARENT_HIERARCHY_TYPE,
	BASE_HIERARCHY_TYPE,
} from '@atlassian/jira-issue-type-hierarchies/src/index.tsx';
import type { InlineCreateState } from '../../reducers/entities/inline-create/types.tsx';
import type { State } from '../../types.tsx';
import { isCmpKanbanProject } from '../app/index.tsx';
import { getCardTypes } from '../card-type/index.tsx';
import { getShowEpicAsPanel } from '../config/index.tsx';
import { getEntities } from '../entities/index.tsx';

export const getInlineCreate = (state: State): InlineCreateState => getEntities(state).inlineCreate;

export const getInlineCreateSessionId = createSelector(
	[getInlineCreate],
	(inlineCreateState) => inlineCreateState?.sessionId,
);

const getInlineCreateCardTypeIds = createSelector(
	[getInlineCreate],
	(inlineCreate) => inlineCreate.cardTypeIds,
);

export const getCardTypesForICC = createSelector(
	[getCardTypes, getInlineCreateCardTypeIds, isCmpKanbanProject, getShowEpicAsPanel],
	(cardTypes, cardTypeIds, isCmpKanban, showEpicAsPanel) =>
		cardTypes
			.filter((cardType) =>
				isCmpKanban && !showEpicAsPanel
					? cardType.typeHierarchyLevel === EPIC_PARENT_HIERARCHY_TYPE ||
						cardType.typeHierarchyLevel === BASE_HIERARCHY_TYPE
					: cardType.typeHierarchyLevel === BASE_HIERARCHY_TYPE,
			)
			.filter((cardType) => cardTypeIds?.includes(cardType.id)),
);
